import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppLinks } from "../../hooks/useAppLinks";
import "./styles.css";

// Âncoras da landing. Usam "/#id" para funcionar também a partir de /terms e /privacy-policy.
export const SECTION_LINKS = [
  { id: "agents", label: "Como funciona" },
  { id: "numbers", label: "Resultados" },
  { id: "security", label: "Segurança" },
  { id: "pricing", label: "Planos" },
  { id: "faq", label: "Dúvidas" },
];

// Transparente no topo: toda página deve começar com uma seção escura (.dark).
const Nav = () => {
  const links = useAppLinks();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 60);
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <header className={`nav ${scrolled ? "solid" : ""}`}>
        <div className="container">
          <Link to="/#hero" className="logo" aria-label="LetsDoc início">
            LetsDoc<b>.</b>
          </Link>
          <nav className="nav-links" aria-label="Menu principal">
            {SECTION_LINKS.map(({ id, label }) => (
              <Link key={id} to={`/#${id}`}>
                {label}
              </Link>
            ))}
          </nav>
          <div className="nav-actions">
            <a className="btn-nav desk" href={links.login}>
              Entrar
            </a>
            <a className="btn btn-primary btn-sm" href={links.signup}>
              Criar conta
            </a>
            <button
              type="button"
              className="hamburger"
              aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((open) => !open)}
            >
              <i />
            </button>
          </div>
        </div>
      </header>

      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        {SECTION_LINKS.map(({ id, label }) => (
          <Link key={id} to={`/#${id}`} onClick={closeMenu}>
            {label}
          </Link>
        ))}
        <a href={links.login} onClick={closeMenu}>
          Entrar
        </a>
      </div>
    </>
  );
};

export default Nav;
